import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { safeExtractFromObject } from '../helpers/helpers';
import BorderlessButton from '../common/buttons/BorderlessButton';
import colors from '../constants/Colors';

export default function TimeCardDatePickerButton({
  arrowDirection,
  onClick,
  visible,
  disabled,
  isTeamCards,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  let iconClassName = 'date-range-picker-icon';
  if (isTeamCards) {
    iconClassName += ' timecards-date-range-picker-icon';
  }
  const icon = arrowDirection === 'left'
    ? <LeftOutlined className={iconClassName} />
    : <RightOutlined className={iconClassName} />;

  const regularStyle = { width: 30,
    backgroundColor: hasRedesign ? colors.BLUE_700 : colors.ONTRACCR_DARK_YELLOW,
    padding:0,
    borderRadius:4,
    opacity: disabled ? 0.25 : 1,
  };

  const teamCardsStyle = {
    width: 32,
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.GRAY_100,
    color: colors.GRAY_800,
    padding: 0,
    borderRadius: 32,
    opacity: disabled ? 0.25 : 1,
  };

  if (!visible) return <Col style={{width:30}} />
  return (
    <Col style={isTeamCards ? { padding: 0 } : {}}>
      <Row justify='center' align='middle'>
        <BorderlessButton
          style={isTeamCards ? teamCardsStyle : regularStyle}
          iconNode={icon}
          onClick={onClick}
          disabled={disabled}
        />
      </Row>
    </Col>
  );
}

TimeCardDatePickerButton.propTypes = {
  arrowDirection: PropTypes.oneOf(['left', 'right']).isRequired,
  onClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  isTeamCards: PropTypes.bool,
};

TimeCardDatePickerButton.defaultProps = {
  disabled: false,
};
